import axios from 'axios';

export function checkHealth() {
  return axios.get('/apigw/v1/health');
}
